// extracted by mini-css-extract-plugin
export default {"multiselect":"xiB_jsT7Nt9n_awmkvDu","multiselectContainer":"qikWzFdUsGmaa8pXmX_w"};